import moment from "moment";
import { notifyFactory } from "@/utils";

export function errorParser(e, message = null, title = null) {
  let errorCode;
  if (e.response) errorCode = e.response.data.no;

  const errorCodeText = `${this.$t("error:title")}№${errorCode}`;
  let isKnownError;

  if (errorCode >= 1000 && errorCode <= 1084) isKnownError = errorCode;
  let errorMessage;
  let errorTitle;

  title ? (errorTitle = title) : (errorTitle = errorCodeText);

  if (message && errorCode) {
    errorMessage = `${message} ${errorCodeText}`;
  } else if (isKnownError && errorCode) {
    switch (isKnownError) {
      case 1009:
        errorMessage = e.response.data.body
          ? `${this.$t("error:" + errorCode)}${e.response.data.body.source_id}`
          : `${this.$t("error:" + errorCode)}`;
        break;
      case 1052:
        if (e.response.data.body) {
          let expirationTime = moment(e.response.data.body.time).format(
            "DD-MM-YYYY HH:MM:SS"
          );
          errorMessage = `${this.$t("error:" + errorCode)}${expirationTime}`;
        } else {
          errorMessage = `${this.$t("error:" + errorCode)}`;
        }
        break;
      case 1073:
        errorMessage = e.response.data.body
          ? `${this.$t("error:" + errorCode)}${e.response.data.body.source_id}`
          : `${this.$t("error:" + errorCode)}`;
        break;
      case 1074:
      case 1075:
        errorMessage = e.response.data.body
          ? `${e.response.data.body.msg}`
          : `${this.$t("error:default")}`;
        break;
      default:
        errorMessage = `${this.$t("error:" + errorCode)}`;
        break;
    }
  } else {
    errorTitle = `${this.$t("error:title")}`;
    errorMessage = `${this.$t("error:default")}`;
  }

  this.$notify(notifyFactory("error", errorTitle, errorMessage));
}
